// Render order of the layout objects: the selected one goes last, so its
// selection frame (the stroke overhangs the geometry) is not painted over by
// neighbouring objects — Konva z-order is the render order.
export const getObjectRenderOrder = (
  objectCount: number,
  selectedIndex: number | null
): number[] => {
  const order = Array.from({ length: objectCount }, (_, index) => index);

  if (selectedIndex === null || selectedIndex >= objectCount) {
    return order;
  }

  order.splice(selectedIndex, 1);
  order.push(selectedIndex);

  return order;
};
